(function () {
  const SWATCH_SELECTOR = '.card__swatch-link';
  const MEDIA_SELECTOR = '.card__media';
  const CARD_SELECTOR = '.card-wrapper';
  const IMG_SELECTOR = '.card__media img:first-child';
  const SWATCH_PREVIEW_CLASS = 'card-wrapper--swatch-preview';
  const MEDIA_HOVER_CLASS = 'card-wrapper--media-hover';

  function getCard(el) {
    return el ? el.closest(CARD_SELECTOR) : null;
  }

  function getPrimaryImg(card) {
    return card.querySelector(IMG_SELECTOR);
  }

  function applyVariantImage(link) {
    const card = getCard(link);
    if (!card) return;
    card.classList.add(SWATCH_PREVIEW_CLASS);
    const img = getPrimaryImg(card);
    if (!img) return;
    const src = link.dataset.variantImage;
    const srcset = link.dataset.variantImageSrcset;
    if (!src) return;
    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.getAttribute('src') || '';
      img.dataset.originalSrcset = img.getAttribute('srcset') || '';
    }
    img.setAttribute('src', src);
    if (srcset) {
      img.setAttribute('srcset', srcset.trim());
    } else {
      img.removeAttribute('srcset');
    }
  }

  function restoreImage(link) {
    const card = getCard(link);
    if (!card) return;
    card.classList.remove(SWATCH_PREVIEW_CLASS);
    const img = getPrimaryImg(card);
    if (!img || !img.dataset.originalSrc) return;
    img.setAttribute('src', img.dataset.originalSrc);
    if (img.dataset.originalSrcset) {
      img.setAttribute('srcset', img.dataset.originalSrcset);
    } else {
      img.removeAttribute('srcset');
    }
  }

  function collect(root, selector) {
    const matches = root.matches?.(selector) ? [root] : [];
    return matches.concat(Array.from(root.querySelectorAll?.(selector) || []));
  }

  function bind(root) {
    const swatches = collect(root || document, SWATCH_SELECTOR);
    const cards = collect(root || document, CARD_SELECTOR);

    swatches.forEach(function (el) {
      if (el.dataset.swatchMediaBound === 'true') return;
      el.dataset.swatchMediaBound = 'true';

      // Hover still gives a temporary preview. Clicking pins the selected
      // finish so dynamically loaded complementary-product cards behave like
      // a small variant picker instead of navigating away.
      el.addEventListener('mouseenter', function () { applyVariantImage(el); });
      el.addEventListener('mouseleave', function () {
        if (el.dataset.previewPinned !== 'true') restoreImage(el);
      });
      el.addEventListener('click', function (e) {
        const card = getCard(el);
        if (!card) return;
        e.preventDefault();
        card.querySelectorAll(SWATCH_SELECTOR).forEach(function (other) {
          delete other.dataset.previewPinned;
          other.classList.remove('is-active');
          other.removeAttribute('aria-current');
        });
        el.dataset.previewPinned = 'true';
        el.classList.add('is-active');
        el.setAttribute('aria-current', 'true');
        applyVariantImage(el);
      });
    });

    cards.forEach(function (card) {
      if (card.dataset.swatchMediaBound === 'true') return;
      card.dataset.swatchMediaBound = 'true';
      const media = card.querySelector(MEDIA_SELECTOR);
      if (!media) return;
      card.addEventListener('mousemove', function (e) {
        const rect = media.getBoundingClientRect();
        const inside =
          e.clientX >= rect.left &&
          e.clientX <= rect.right &&
          e.clientY >= rect.top &&
          e.clientY <= rect.bottom;
        card.classList.toggle(MEDIA_HOVER_CLASS, inside);
      });
      card.addEventListener('mouseleave', function () {
        card.classList.remove(MEDIA_HOVER_CLASS);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  // Product recommendations are injected after page load, so bind swatches
  // as soon as Shopify adds those cards to the DOM.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE) bind(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('focusin', function (e) {
    const link = e.target.closest(SWATCH_SELECTOR);
    if (link) applyVariantImage(link);
  });

  document.addEventListener('focusout', function (e) {
    const link = e.target.closest(SWATCH_SELECTOR);
    if (link && link.dataset.previewPinned !== 'true') restoreImage(link);
  });
})();
